module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.routes), function(item, index) {
    return _c('div', {
      key: index
    }, [(!item.hidden && item.noDropdown) ? _c('div', [(item.type === "window") ? _c('a', {
      staticClass: "menu-indent",
      on: {
        "click": function($event) {
          return _vm.openUrl(item.path)
        }
      }
    }, [_c('li', {
      staticClass: "el-menu-item",
      staticStyle: {
        "background-color": "rgb(255, 255, 255)"
      },
      attrs: {
        "role": "menuitem",
        "tabindex": "-1"
      }
    }, [(item.icon) ? _c('wscn-icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v("\n                    " + _vm._s(item.name) + "\n                ")], 1)]) : _vm._e(), _vm._v(" "), (item.type !== "window") ? _c('router-link', {
      staticClass: "menu-indent",
      attrs: {
        "to": item.path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.path
      }
    }, [(item.icon) ? _c('wscn-icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v("\n                    " + _vm._s(item.name) + "\n                ")], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon) ? _c('wscn-icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v("\n                " + _vm._s(item.name) + "\n            ")], 1), _vm._v(" "), _vm._l((item.children), function(child, childIndex) {
      return (!child.hidden && child.yon == 'Y') ? _c('div', {
        key: childIndex
      }, [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _vm._e(), _vm._v(" "), (child.type === "window") ? _c('a', {
        staticClass: "menu-indent",
        on: {
          "click": function($event) {
            return _vm.openUrl(child.path)
          }
        }
      }, [_c('li', {
        staticClass: "el-menu-item",
        staticStyle: {
          "padding-left": "40px",
          "background-color": "rgb(255, 255, 255)"
        },
        attrs: {
          "role": "menuitem",
          "tabindex": "-1"
        }
      }, [_vm._v("\n                        " + _vm._s(child.name) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (child.type !== "window") ? _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                        " + _vm._s(child.name) + "\n                    ")])], 1) : _vm._e()], 1) : _vm._e()
    })], 2) : _vm._e()], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-025e7312"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/SidebarItem.vue
// module id = 1764
// module chunks = 502